module.exports = __webpack_public_path__ + "static/media/Arrow_down_dark.7455c78d.svg";